import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header header-elements-inline bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Übersicht Ihrer Alarme")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "media-list media-list-linked media-list-bordered"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "mr-3 d-flex flex-column align-items-center" }
const _hoisted_8 = { class: "mr-md-5 d-flex flex-column overflow-hidden text-opac-right" }
const _hoisted_9 = { class: "font-weight-bold" }
const _hoisted_10 = { class: "text-muted font-size-sm" }
const _hoisted_11 = { class: "font-size-sm" }
const _hoisted_12 = { class: "media-body align-self-start d-none d-lg-block mr-3" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Auslösegrund ")
const _hoisted_14 = { class: "text-muted" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "ml-auto d-flex flex-md-row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "list-icons-item"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)
const _hoisted_16 = {
  key: 1,
  class: "card-body"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-info col-12 mb-0" }, "Sie haben noch keine Alarme", -1)
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterBar = _resolveComponent("FilterBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createVNode(_component_FilterBar, {
      filter: _ctx.filter,
      search: _ctx.search,
      onFilter: _ctx.onFilter
    }, null, 8, ["filter", "search", "onFilter"]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_ctx.alerts.length > 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: ""
              }, [
                _createElementVNode("a", {
                  class: "media cursor-pointer align-items-center",
                  onClick: ($event: any) => (_ctx.showDetail(alert))
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["btn bg-transparent rounded-pill border-2 btn-icon ml-2 mr-2 ml-md-3 mr-md-3", 'text-'+alert.class])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(alert.icon)
                      }, null, 2)
                    ], 2),
                    _createElementVNode("small", {
                      class: _normalizeClass(["mx-auto", 'text-'+alert.class])
                    }, _toDisplayString(alert.name), 3)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(alert.p_strasse) + " " + _toDisplayString(alert.p_hnr) + " | " + _toDisplayString(alert.p_plz) + " " + _toDisplayString(alert.p_ort), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(alert.p_vorname) + " " + _toDisplayString(alert.p_name), 1),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(alert.createdAt) + " Uhr", 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, _toDisplayString(alert.grund), 1)
                  ]),
                  _hoisted_15
                ], 8, _hoisted_6)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
    ])
  ]))
}